import React from 'react';
export function Hero() {
  return <section className="pt-8 pb-6 px-4 max-w-5xl mx-auto text-center" data-id="element-101">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-oswald font-bold text-slate-900 mb-5 leading-tight uppercase tracking-tight" data-id="element-102">
        Resolvé tu año de clases y{' '}
        <span className="text-blue-600" data-id="element-103">volve a disfrutar</span> de enseñar
        handball
      </h1>

      <div className="relative max-w-[80%] mx-auto mb-6" data-id="element-104">
        <div className="absolute inset-0 bg-blue-600 blur-3xl opacity-20 rounded-full" data-id="element-105"></div>
        <img src="https://cdn.magicpatterns.com/uploads/3QQC6dhgDedrJ4zcpy4U6k/ChatGPT_Image_May_26,_2026,_10_47_02_PM.png" alt="Handball Coach Pro Bundle" className="relative z-10 w-full h-auto rounded-xl shadow-2xl border border-slate-200" data-id="element-106" />
      </div>

      <p className="text-base md:text-lg text-slate-700 max-w-2xl mx-auto font-medium leading-relaxed" data-id="element-107">
        <strong className="text-blue-700" data-id="element-108">Handball Coach Pro</strong> es un
        sistema de recursos, clases listas según la edad de tu grupo y
        prevención de lesiones, pensado para profes de handball que quieren
        hacer su clase más eficiente sin perder calidad.
      </p>
    </section>;
}